// extracted by mini-css-extract-plugin
export var bannerContainer = "JoinBanner-module--bannerContainer--B4Z1p";
export var bannerImageDesktop = "JoinBanner-module--bannerImageDesktop--nx0+Q";
export var bannerImageMobile = "JoinBanner-module--bannerImageMobile--c7oqv";
export var joinBannerWrapper = "JoinBanner-module--joinBannerWrapper--BSOic";
export var overlayContent = "JoinBanner-module--overlayContent--VrRXe";
export var textBox = "JoinBanner-module--textBox--T7N0W";
export var title = "JoinBanner-module--title--Ln2TN";